
import React, {useEffect,useState} from 'react'
import {Row} from 'antd';
import MapStyleBrown from './customMapStyle';
import * as http from '@/common/api/apparatusManagement/gisMap';
import * as Dict from '@/common/api/system/dict';

import './map.css';
import icn from '@/common/images/s_ico10.png';
import m0 from '@/common/images/m0.png'
import m1 from '@/common/images/m1.png'
import m2 from '@/common/images/m2.png'
import m3 from '@/common/images/m3.png'
import m4 from '@/common/images/m4.png'
// import img from '@/common/images/s_ico4.png'
function BaiduMap(props) {
    const [isSeachType, setIsSeachType] = useState(false);
    const [record, setRecord] = useState({});
    const [facilitiesVisible, setfacilitiesVisible] = useState(false);
    const [devTypeList, setdevTypeList] = useState([])
    const [mapPointList, setMapPointList] = useState([])
    const [installationStatusType, setInstallationStatusType] = useState([])
    // 显示搜素哦框
    const openSearchInput = () => {
        setIsSeachType(true)
    }
    // 搜索框搜素数据
    const handleSeachData = () =>{
        setIsSeachType(false)
    }
    const getInstallationIcon = (status,iconList) => {
        let icon = icn;
        iconList.map(item => {
            if(item.iconType === status){
                const fileItem = JSON.parse(item.iconUrl)
                icon = fileItem.url
            }
        })
        return  icon;
    }
    // 设施模态框配置项
    const facilitiesModal = {
        width: 270,
        footer: null,
        onCancel: ()=>setfacilitiesVisible(false),
        title: '设施详情',
        visible: facilitiesVisible,
        mask: false,
        keyboard: false,
        maskClosable: false
    }
    function createItemDom (item) {
        return `<div>
                <p><span>设施类型：</span><span>${item.devTypeLabel}</span></p>
                <p><span>设施名称：</span><span>${item.instName}</span></p>
                <p><span>设施状态：</span><span>${item.statusLabel}</span></p>
                <p><span>设施数量：</span><span>1</span></p>
                <p><span>权属公司：</span><span></span></p>
            </div>`
    }
    // 地图
    const baiDuMap = (list) => {
        let markers = []
        // 创建Map实例
        const map = new window.BMap.Map('indexMap');
        // 初始化地图,用城市名设置地图中心点
        map.centerAndZoom(new window.BMap.Point(117.77801864, 39.161705779),14);
        // 是否缩放
        map.enableScrollWheelZoom(true)
        // 设置主题样式
        const mapStyleBrown = MapStyleBrown
        map.setMapStyleV2({styleJson:eval('mapStyleBrown')});
        // 清除所有覆盖物
        map.clearOverlays()
        // 向地图添加标注
        if (list && list.length > 0) {
            list.map(item => {
                let point = new window.BMap.Point(item.longitude,item.latitude);
                // 自定义标注图
                let myIcon = new window.BMap.Icon(getInstallationIcon(item.status,item.iconList), new window.BMap.Size(32, 32))
                myIcon.setImageSize(new window.BMap.Size(32,32))
                // 创建标注对象并添加到地图
                let marker = new window.BMap.Marker(point,{icon: myIcon});
                // 点聚合
                markers.push(marker)
                // 点击标注事件
                const opts = {
                    width: 200,
                    height: 130,
                    title: item.sn
                }
                devTypeList.some(i => {
                    if(item.devTypeId === i.id) {
                        item.devTypeLabel = i.name
                        return true
                    }
                })
                installationStatusType.some(i => {
                    if (item.status === i.dictValue) {
                        item.statusLabel = i.dictLabel
                    }
                })
                const infoWindow = new window.BMap.InfoWindow(createItemDom(item), opts);
                marker.addEventListener('click', function () {
                    map.openInfoWindow(infoWindow, point);
                })
            })
        }
        const markerClusterer = new window.BMapLib.MarkerClusterer(map, {markers: markers})
        const styles = markerClusterer.getStyles()
        if(styles && styles.length > 0){
            styles.forEach(item => {
                if(item.url.lastIndexOf('mo.png') !== -1){
                    item.url = m0
                }
                if(item.url.lastIndexOf('m1.png') !== -1){
                    item.url = m1
                }
                if(item.url.lastIndexOf('m2.png') !== -1){
                    item.url = m2
                }
                if(item.url.lastIndexOf('m3.png') !== -1){
                    item.url = m3
                }
                if(item.url.lastIndexOf('m4.png') !== -1){
                    item.url = m4
                }
            })
            markerClusterer.setStyles(styles)
        }
    }
    // 查询数据方法
    const facilitiesQuery = () => {
        const params = {type: '1'}
        http.getFacilities(params).then(res => {
            if (res.code === 0 && res.data.length >0) {
                baiDuMap(res.data)
                setMapPointList([...res.data])
            }
        })
    }
    // 设施类型
    const facilitiesType = () => {
        http.getType({type: 1}).then(res => {
            if (res.code === 0) {
                setdevTypeList([...res.data])
            }
        })
        Dict.getDictDataListByDictType({dictCode: 'installationStatusType'}).then(res => {
            if (res.code === 0) {
                setInstallationStatusType(res.data)
            }
        })
    }
    useEffect(() => {
        facilitiesQuery()
        facilitiesType()
    },[])
    useEffect(() => {
        if (mapPointList.length>0){
            baiDuMap(mapPointList)
        }else {
            baiDuMap()
        }
    },[mapPointList,devTypeList,installationStatusType])
    return (
        <div style={{position: 'relative'}}>
            <div style={{position: 'absolute',top: '12px',left : '0px',zIndex : '999', width: '100%'}}>
                <Row justify="end" className="btnLayer" gutter={24}>
                    <a className="map-search" style={{display:isSeachType ? 'none':'block'}} onClick={openSearchInput}><span className="icon-seach"></span></a>
                    <div className="search-box" style={{display:isSeachType ? 'block':'none'}}>
                        <form className="search-form clearfix">
                            <button className="icoSearch" onClick={handleSeachData}></button>
                            <input type="text" name="" placeholder="请搜索设施"></input>
                        </form>
                    </div>
                    {/* <Col span={6}>
                        <input id="street" placeholder="请输入街道地点" style={{width: '200px'}} />
                    </Col> */}
                    {/* <Col span={6}>
                        <Button id="reset" style={{marginLeft: '12px'}} type="primary">重置</Button>
                    </Col> */}
                </Row>
                {/* <Row justify="end" className="btnLayer" gutter={24}>
                    <a className="map-search"><span className="ico-car"></span></a>
                </Row> */}
            </div>
            <div id="indexMap" style={{width: '100%',height: '480px', borderRadius:'15px'}}></div>
        </div>
    )
}
export default BaiduMap
